export default "__VITE_ASSET__DgUNxeZB__"